import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Layers } from 'lucide-react'
import { WorkspacesScreen } from '@/screens/org/SCR-143-workspaces'

export const Route = createFileRoute('/_app/org/workspaces')({
  staticData: { screen: { id: 'SCR-143', title: 'Workspaces', group: 'Organisation', perm: 'workspace.read', order: 4, description: 'Workspaces in this organisation, their members, teams and team memory.', icon: Layers } },
  validateSearch: z.object({
    status: z.enum(['all', 'active', 'archived']).optional().catch(undefined),
    new: z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean()).optional().catch(undefined),
  }),
  component: WorkspacesScreen,
})
